import MPACustomerDetails from './MPACustomerDetails';

export default MPACustomerDetails;
